export enum adminApplicantsListTypes {
    FETCH_ADMIN_APPLICANTS_LIST_REQUEST = "FETCH_ADMIN_APPLICANTS_LIST_REQUEST",
    FETCH_ADMIN_APPLICANTS_LIST_SUCCESS = "FETCH_ADMIN_APPLICANTS_LIST_SUCCESS",
    FETCH_ADMIN_APPLICANTS_LIST_FAILURE = "FETCH_ADMIN_APPLICANTS_LIST_FAILURE",
  }